// src/Components/MobileDrawerMenu.js
import React, { useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "../Styles/MobileDrawerMenu.module.css";

import { useUsers } from "../Commoncontext/UsersContext";
import { useSelectedCompany } from "../Commoncontext/SelectedCompanyContext";
import { useCompanyConfig } from "../Commoncontext/CompanyConfigContext";
import { useCompany } from "../Commoncontext/CompanyContext";

import {
  getVisibleNavigationItems,
  getMobileNavigationItems,
} from "../Utils/navigationUtils";

import IconHome from "../Images/IconHome";
import IconScreen from "../Images/IconScreen";
import IconSauna from "../Images/IconSauna";
import IconAnnouncements from "../Images/IconAnnouncements";
import IconServicerequests from "../Images/IconServicerequests";

const ICONS = {
  home: IconHome,
  screen: IconScreen,
  sauna: IconSauna,
  announcements: IconAnnouncements,
  servicerequests: IconServicerequests,
};

function MobileDrawerMenu({ onClose }) {
  const { user } = useUsers();
  const { selectedCompanyId, setSelectedCompanyId } = useSelectedCompany();
  const { companyName } = useCompany();
  const { enabledItems } = useCompanyConfig();
  const location = useLocation();

  const [showCompanySwitcher, setShowCompanySwitcher] = useState(false);

  const visibleItems = useMemo(() => {
    return getVisibleNavigationItems({
      enabledItems,
      user,
      selectedCompanyId,
    });
  }, [enabledItems, user, selectedCompanyId]);

  const mobileItems = useMemo(() => {
    return getMobileNavigationItems(visibleItems);
  }, [visibleItems]);

  const hasMultipleCompanies = user?.companies?.length > 1;

  const handleCompanySelect = (companyId) => {
    setSelectedCompanyId(companyId);
    setShowCompanySwitcher(false);
    onClose?.();
  };

  if (!user) return null;

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />

      <div className={styles.drawer}>
        <div className={styles.drawerHeader}>
         <button
          className={styles.companySelector}
          type="button"
          onClick={() => {
            if (hasMultipleCompanies) {
              setShowCompanySwitcher(true);
            }
          }}
          disabled={!hasMultipleCompanies}
         >
         <span className={styles.companyName}>
          {companyName || "Valitse taloyhtiö"}
         </span>
         {hasMultipleCompanies && (
           <span className={styles.companyChevron}>⌄</span>
         )}
        </button>
       </div>
        <nav className={styles.nav}>
          {mobileItems.map((item) => {
            const Icon = ICONS[item.icon] || null;
            const isActive = location.pathname === item.route;

            return (
              <NavLink
                key={item.key}
                to={item.route}
                onClick={onClose}
                className={`${styles.navItem} ${isActive ? styles.active : ""}`}
              >
                <span className={styles.activeBar} aria-hidden="true" />
                <span className={styles.iconWrap}>{Icon && <Icon />}</span>
                <span className={styles.linkText}>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <button className={styles.drawerCloseBottom} onClick={onClose} type="button">
          Sulje <span>×</span>
        </button>
      </div>

      {showCompanySwitcher && (
        <>
          <div
            className={styles.companySheetBackdrop}
            onClick={() => setShowCompanySwitcher(false)}
          />

          <div className={styles.companySheet}>
            <div className={styles.companySheetHandle} />

            <h2 className={styles.companySheetTitle}>Vaihda taloyhtiötä</h2>

            <div className={styles.companyList}>
              {user.companies.map((companyId) => {
                const isSelected = companyId === selectedCompanyId;
                const name = user.companyNames?.[companyId] || companyId;

                return (
                  <button
                    key={companyId}
                    type="button"
                    className={`${styles.companyOption} ${
                      isSelected ? styles.companyOptionSelected : ""
                    }`}
                    onClick={() => handleCompanySelect(companyId)}
                  >
                    <span className={styles.companyCheck}>
                      {isSelected ? "✓" : ""}
                    </span>

                    <span className={styles.companyOptionText}>
                      <span className={styles.companyOptionName}>{name}</span>
                      {isSelected && (
                        <span className={styles.companyOptionSub}>
                          Nykyinen yhtiö
                        </span>
                      )}
                    </span>
                  </button>
                );
              })}
            </div>

            <button
              type="button"
              className={styles.companySheetCancel}
              onClick={() => setShowCompanySwitcher(false)}
            >
              Peruuta
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default MobileDrawerMenu;